import { Component, Input, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ConfigurationServices } from "../services";
import { ConfigurationComplementsCreateListPage } from './configuration-complements-create/configuration-complements-create-list/configuration-complements-create-list';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { TranslateService } from '@ngx-translate/core';
import { ComplementsCreateDishSelectPage } from '../../complements/complements-partial-select/complements-create-dish-select/complements-create-dish-select';


/**
 * Generated class for the ConfigurationRoomsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-complements',
  templateUrl: 'configuration-complements.html',
})
export class ConfigurationComplementsPage {

  //datatable
  sorts = [
    { prop: 'name', dir: 'asc' },
    { prop: 'cost_extra', dir: 'asc' },
    { prop: 'quantity', dir: 'asc' },
    { prop: 'multiSelect', dir: 'asc' },
    { prop: 'deleteOp', dir: 'asc' },
    // { prop: 'activeOn', dir: 'asc' },
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  @Input() type: string = 'groupComp';
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService) {

    this.globals.GAtrackView('Configuration', 'Configuration - Variations - View ', this.globals.restaurant.email, 'View', 'List variations', 'Configuration', '');
  }

  ngOnInit(): void {
    this.configurationServices.getComplementsGroups();
    this.configurationServices.getPagesVariations();
  }

  ionViewWillEnter() {
    this.configurationServices.getComplementsGroups();
    this.configurationServices.getPagesVariations();
  }

  ionViewWillLeave() {
    this.configurationServices.complements_searchbar_text = '';
    this.configurationServices.complements_group_searchbar_text = '';
    this.configurationServices.showIngredients = true;
    this.configurationServices.showArticles = true;
  }

  createGroupComplements() {
    this.navCtrl.push(ComplementsCreateDishSelectPage, {
      update: false,
      section: {},
      section_index: null,
      uid: null
    });
  }

  createComplement() {
    this.navCtrl.push(ConfigurationComplementsCreateListPage, {
      type: 'all'
    });
  }

  clickComplement(event) {
    if (event.type == 'click') {
      this.navCtrl.push(ConfigurationComplementsCreateListPage, {
        variation: event.row,
        update_state: true,
        type: event.row.type,
      }).then(() => {
        this.configurationServices.getPagesVariations(); // Refresh after edit
      });
    }
  }

  clickGroup(event) {
    if (event.type == 'click') {
      const rowIndex = this.configurationServices.complements_group_array.findIndex(row => row.name === event.row.UID);
      this.navCtrl.push(ComplementsCreateDishSelectPage, {
        section: event.row,
        update: true,
        section_index: rowIndex === -1 ? null : rowIndex,
        uid: event.row.UID
      });
    }
  }

  onSort(event) {
    let targetArray;

    if (this.type === 'groupComp') {
      targetArray = [...this.configurationServices.complements_group_array_filtered];
    } else {
      targetArray = [...this.configurationServices.complements_array_filtered];
    }

    if (!targetArray || targetArray.length === 0) return;

    const sortColumn = event.column.prop; // Nombre de la columna
    const sortDirection = event.newValue === 'asc' ? 1 : -1;

    targetArray.sort((a, b) => {
      let valueA, valueB;

      switch (sortColumn) {
        case 'quantity':
          valueA = this.type === 'groupComp' ? (a.complements ? a.complements.length : 0) : (a.quantity ? parseFloat(a.quantity) : 0);
          valueB = this.type === 'groupComp' ? (b.complements ? b.complements.length : 0) : (b.quantity ? parseFloat(b.quantity) : 0);
          break;

        case 'cost_extra':
          valueA = this.type === 'groupComp' ? (a.cost_extra ? 1 : 0) : (a.price && a.price > 0 ? 1 : 0);
          valueB = this.type === 'groupComp' ? (b.cost_extra ? 1 : 0) : (b.price && b.price > 0 ? 1 : 0);
          break;

        case 'multiSelect':
          valueA = a.select_multi ? 1 : 0;
          valueB = b.select_multi ? 1 : 0;
          break;

        case 'deleteOp':
          valueA = a.quit_elements ? 1 : 0;
          valueB = b.quit_elements ? 1 : 0;
          break;

        // case 'activeOn':
        //   valueA = this.getComplementGroupCount(a.uid_element) || 0;
        //   valueB = this.getComplementGroupCount(b.uid_element) || 0;
        //   break;

        default:
          valueA = a[sortColumn] || '';
          valueB = b[sortColumn] || '';
      }

      if (!isNaN(parseFloat(valueA)) && !isNaN(parseFloat(valueB))) {
        return sortDirection * (parseFloat(valueA) - parseFloat(valueB));
      }

      return sortDirection * valueA.toString().localeCompare(valueB.toString(), undefined, { numeric: true });
    });

    if (this.type === 'groupComp') {
      this.configurationServices.complements_group_array_filtered = [...targetArray];
    } else {
      this.configurationServices.complements_array_filtered = [...targetArray];
    }
  }

  activeTab(value) {
    if (this.type == value) {
      let cssClasses = {
        'active': true,
        'nav-link': true,
        'space-norwap': true,
        'text-uppercase': true
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'active': false,
        'nav-link': true,
        'space-norwap': true,
        'text-uppercase': true
      }
      return cssClasses;
    }
  }

  openComplementsGroup() {
    this.type = 'groupComp';
  }

  openComplements() {
    this.type = 'complements';
  }

  getComplementGroupCount(complementUID: string): number {
    if (!this.configurationServices.complements_group_array) return 0;

    return this.configurationServices.complements_group_array.reduce((count, group) => {
      if (group.complements && group.complements.some(comp => comp === complementUID)) {
        return count + 1;
      }
      return count;
    }, 0);
  }

}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-complements/configuration-complements.ts